import React from 'react';
import { createRoot } from 'react-dom/client';

import AppRouter from './app/router/AppRouter.tsx';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppRouter tab="home" />);